import { questionTypes, creatorTypes } from "./options"

const getOptionName = (options, selectedType) => {
  const selectedOption = options.find((option) => option.type === selectedType)
  return selectedOption?.title
}
export const getQuestionTypeName = (type) => getOptionName(questionTypes, type)
export const getCreatorTypeName = (type) => getOptionName(creatorTypes, type)
